export default __webpack_public_path__ + "static/media/hatIcon.0c9b6ab5.svg";